import React, { createContext, useContext, useEffect, useState } from 'react';
import { fetchPublicLocation } from './utils/publicDocsApi';

// Create the context
const LocationContext = createContext();

// Create a custom hook for easier usage
export const useLocation = () => useContext(LocationContext);

export const LocationProvider = ({ children }) => {
  const [location, setLocation] = useState(null);
  const [currency, setCurrency] = useState(null); // State for currency info

  // Fetch user location and currency info when the component mounts
  useEffect(() => {
    fetchPublicLocation()
      .then((payload) => {
        setLocation(payload?.location || null);
        setCurrency(payload?.currency || null);
      })
      .catch(() => {
        setLocation({
          city: "Nairobi",
          region: "Nairobi Default",
          country: "KE",
          timezone: "Africa/Nairobi",
          userLat: "-1.2833",
          userLng: "36.8167",
        });
        setCurrency({
          name: "Kenyan Shilling",
          symbol: "KSh",
          code: "KES",
          countryName: "Kenya",
          flag: null,
        });
      });
  }, []);
  
  return (
    <LocationContext.Provider value={{ location, currency }}>
      {children}
    </LocationContext.Provider>
  );
};
 
